import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";
import {ThaiStatusPipe} from "./thai_status.pipe";
import {TruncatePipe} from "./truncate-pipe";
import {BankNamePipe} from "./bank_name.pipe";
import {MomentPipe} from "./momentPipe";


@NgModule({
  declarations:[ThaiStatusPipe,TruncatePipe,BankNamePipe,MomentPipe],
  imports:[CommonModule],
  exports:[ThaiStatusPipe,TruncatePipe,BankNamePipe,MomentPipe],
})

export class MainPipe{}



// WEBPACK FOOTER //
// ./src/app/pipe/main-pipe.module.ts